import * as xlsx from 'xlsx';

const COLUMN_MAP = {
  nombre: 'Nombre',
  apellido: 'Apellido',
  'correo electronico': 'Correo electronico',
};

export const parseExcelBuffer = (buffer) => {
  try {
    const wb = xlsx.read(buffer, { type: 'array' });
    const ws = wb.Sheets[wb.SheetNames[0]];
    const raw = xlsx.utils.sheet_to_json(ws, { defval: '' });

    if (!raw.length) return { rows: [], error: 'El archivo no contiene filas.' };

    const firstRow = raw[0];
    const headerMap = {};
    Object.keys(firstRow).forEach((k) => {
      headerMap[k.trim().toLowerCase()] = k;
    });

    const missing = Object.keys(COLUMN_MAP).filter((r) => !headerMap[r]);
    if (missing.length) {
      return {
        rows: [],
        error: `Columnas faltantes: ${missing.map((m) => COLUMN_MAP[m]).join(', ')}`,
      };
    }

    const rows = raw
      .map((r) => ({
        Nombre: String(r[headerMap['nombre']] || '').trim(),
        Apellido: String(r[headerMap['apellido']] || '').trim(),
        'Correo electronico': String(r[headerMap['correo electronico']] || '').trim(),
      }))
      .filter((r) => r.Nombre || r.Apellido); // keep rows with at least one name field

    if (!rows.length) {
      return { rows: [], error: 'El archivo no contiene filas válidas.' };
    }

    return { rows, error: null };
  } catch (_) {
    return { rows: [], error: 'No se pudo leer el archivo. Verificá que sea un .xlsx o .csv válido.' };
  }
};

export const downloadTemplate = () => {
  const wb = xlsx.utils.book_new();
  const ws = xlsx.utils.aoa_to_sheet([
    ['Nombre', 'Apellido', 'Correo electronico'],
    ['Juan', 'Perez', 'juan@example.com'],
  ]);
  xlsx.utils.book_append_sheet(wb, ws, 'Plantilla');
  xlsx.writeFile(wb, 'plantilla-invitaciones.xlsx');
};
